<div class="container py-5">
  <h2 class="text-lg-center text-start fs-1 text-white fw-bold">
    {{ "contactUs.TitleContactUs" | translate }}
  </h2>

  <form [formGroup]="contactForm" class="text-white">
    <div class="row g-3 justify-content-center">
      <div class="col-12 col-md-6 col-lg-5">
        <label for="firstName" class="form-label">
          {{ "contactUs.firstName" | translate }}
        </label>
        <input
          id="firstName"
          type="text"
          formControlName="senderFirstName"
          class="form-control"
          [class.is-invalid]="
            isSubmitted && getContactControl('senderFirstName')?.invalid
          "
        />

        @if (isSubmitted && getContactControl('senderFirstName')?.invalid) {
        <div class="text-danger mt-1">
          @if (getContactControl('senderFirstName')?.errors?.['required']) {
          <small>First name is required.</small>
          } @if (getContactControl('senderFirstName')?.errors?.['pattern']) {
          <small>Please enter a valid name.</small>
          }
        </div>
        }
      </div>

      <div class="col-12 col-md-6 col-lg-5">
        <label for="lastName" class="form-label">
          {{ "contactUs.lastName" | translate }}
        </label>
        <input
          id="lastName"
          type="text"
          formControlName="senderLastName"
          class="form-control"
          [class.is-invalid]="
            isSubmitted && getContactControl('senderLastName')?.invalid
          "
        />

        @if (isSubmitted && getContactControl('senderLastName')?.invalid) {
        <div class="text-danger mt-1">
          @if (getContactControl('senderLastName')?.errors?.['required']) {
          <small>Last name is required.</small>
          } @if (getContactControl('senderLastName')?.errors?.['pattern']) {
          <small>Please enter a valid last name.</small>
          }
        </div>
        }
      </div>

      <div class="col-12 col-md-6 col-lg-5">
        <label for="email" class="form-label">
          {{ "contactUs.email" | translate }}
        </label>
        <input
          id="email"
          type="email"
          formControlName="senderEmail"
          class="form-control"
          [class.is-invalid]="
            isSubmitted && getContactControl('senderEmail')?.invalid
          "
        />

        @if (isSubmitted && getContactControl('senderEmail')?.invalid) {
        <div class="text-danger mt-1">
          @if (getContactControl('senderEmail')?.errors?.['required']) {
          <small>Email address is required.</small>
          } @if (getContactControl('senderEmail')?.errors?.['email'] ||
          getContactControl('senderEmail')?.errors?.['pattern']) {
          <small>Please enter a valid email.</small>
          }
        </div>
        }
      </div>

      <div class="col-12 col-md-6 col-lg-5">
        <label for="phone" class="form-label">
          {{ "contactUs.phone" | translate }}
        </label>

        <ngx-intl-tel-input
          [cssClass]="'shared-input mt-2'"
          [preferredCountries]="[
            CountryISO.SaudiArabia,
            CountryISO.UnitedArabEmirates,
            CountryISO.Egypt
          ]"
          [enableAutoCountrySelect]="false"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryField]="[
            SearchCountryField.Name,
            SearchCountryField.DialCode
          ]"
          [separateDialCode]="true"
          [selectedCountryISO]="CountryISO.Egypt"
          formControlName="mobilePhone"
        />
        @if (isSubmitted && getContactControl('mobilePhone')?.invalid) {
        <div class="text-danger mt-1">
          @if (getContactControl('mobilePhone')?.errors?.['required']) {
          <small>Phone number is required.</small>
          }
        </div>
        }
      </div>

      <div class="col-12 col-lg-10">
        <label for="details" class="form-label">
          {{ "contactUs.description" | translate }}
        </label>
        <textarea
          id="details"
          rows="6"
          formControlName="emailBody"
          class="form-control"
          [class.is-invalid]="
            isSubmitted && getContactControl('emailBody')?.invalid
          "
        ></textarea>

        @if (isSubmitted && getContactControl('emailBody')?.invalid) {
        <div class="text-danger mt-1">
          @if (getContactControl('emailBody')?.errors?.['required']) {
          <small>This field is required.</small>
          } @if (getContactControl('emailBody')?.errors?.['minlength']) {
          <small>Minimum length is 10 characters.</small>
          }
        </div>
        }

        <div class="row submitButton justify-content-end mt-3">
          <button
            type="submit"
            (click)="onSubmit()"
            class="col-12 col-md-2 btn btn-dark text-white py-2"
          >
            {{ "contactUs.submitButton" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

@if (showSuccessModal) {
<app-success-modal (close)="showSuccessModal = false"></app-success-modal>
}
